export default __webpack_public_path__ + "assets/feb3361504a20cc90ae9f70256bd5fa8.svg";